export interface DeliveryAddressStringInterface {
  SAME_ADDRESS: string;
  OTHER_ADDRESS: string;
  AT_THE_STORE: string;
}
export interface DeliveryMethodStringInterface {
  NEKOPOS: string;
  YAMATO: string;
}
export interface PaymentMethodStringInterface {
  CREDIT_CARD: string;
  CONVENIENCE_STORE: string;
  BANK_AND_POSTAL_SERVICE: string;
  CASH_ON_DELIVERY: string;
  CASH_PAYMENTS: string;
}

export const DELIVERY_ADDRESS = {
  OTHER_ADDRESS: "ご希望のご住所へお届け",
  AT_THE_STORE: "ご来店受け取り"
} as DeliveryAddressStringInterface;

export const REPEAT_DELIVERY_ADDRESS = {
  SAME_ADDRESS: "前回注文と同じご住所へ郵送",
  OTHER_ADDRESS: "別のご住所へお届け",
  AT_THE_STORE: "ご来店受け取り"
} as DeliveryAddressStringInterface;

export const MANUSCRIPT_DELIVERY_ADDRESS = {
  OTHER_ADDRESS: "ご希望のご住所へお届け",
  AT_THE_STORE: "ご来店受け取り"
} as DeliveryAddressStringInterface;

export const DELIVERY_METHOD = {
  NEKOPOS: "ネコポス（日時指定不可）",
  YAMATO: "ヤマト宅急便（日時指定可）"
} as DeliveryMethodStringInterface;

export const PAYMENT_METHOD = {
  CREDIT_CARD: "クレジットカード決済",
  CONVENIENCE_STORE: "コンビニ振込（前払い）",
  BANK_AND_POSTAL_SERVICE: "銀行・郵便振込（前払い）",
  CASH_ON_DELIVERY: "代金引換",
  CASH_PAYMENTS: "ご来店現金支払い"
} as PaymentMethodStringInterface;
